module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "position": "is-centered"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Search")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "position": "is-right"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-info"
  }, [_vm._v("Search")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7034d8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExPositions.vue
// module id = 1080
// module chunks = 5 221